export default function lazyDeepCopy<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}
